import dayjs from 'dayjs';
import { TaskStatus, TaskType } from '../task';
import { AssetTransactionStatus } from '../asset_transaction/assetTransaction';
import { FlowType } from '../order/orderFlow';

export enum MetricInterval {
  hour = 'hour',
  day = 'day',
  month = 'month',
  year = 'year',
}

export enum MetricEntityType {
  productMasterData = 'productMasterData',
  stockLocation = 'stockLocation',
  order = 'order',
  task = 'task',
  asset = 'asset',
  user = 'user',

  transaction = 'transaction',
  action = 'action',

  productTransaction = 'productTransaction',
  taskProduct = 'taskProduct',
  assetTransaction = 'assetTransaction',
}

export class MetricFilter {
  start: Date = dayjs().subtract(7, 'day').startOf('day').toDate();
  end: Date = dayjs().endOf('day').toDate();
  interval: MetricInterval = MetricInterval.day;

  companyIds: string[] = [];

  orderType: FlowType[] = [];
  orderStatus: string[] = [];

  taskType: TaskType[] = [];
  taskStatus: TaskStatus[] = [];

  assetStatus: AssetTransactionStatus[] = [];

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}
